import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es digital?',
    a: 'Sí, acceso inmediato.'
  }, {
    q: '¿Necesito saber cocinar?',
    a: 'No, es simple y práctico.'
  }, {
    q: '¿Es solo para madres?',
    a: 'No, para cualquier mujer con poco tiempo.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí, 7 días.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-sage py-16 px-4 flex flex-col items-center" data-id="element-21">
      <div className="max-w-3xl w-full" data-id="element-22">
        <h2 className="text-3xl md:text-4xl font-bold text-brown-800 mb-10 text-center" data-id="element-23">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-24">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-green-100 overflow-hidden" data-id="element-25">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-26">
                <span className="font-bold text-brown-800 text-lg pr-4" data-id="element-27">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="text-gold-500 shrink-0" data-id="element-28" /> : <ChevronDown className="text-brown-400 shrink-0" data-id="element-29" />}
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-30">
                <p className="text-brown-600 text-lg" data-id="element-31">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}